const isUrl = function (str) {
    return /^((ht|f)tps?):\/\/[\w-]+(\.[\w-]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?$/.test(str);
}
const getDate = function (date) {
    let arr = date.split(/[-:\s]/);
    if(arr.length < 6) {
        arr[5] = 0;
    }
    return new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]);
}
const getNowTimeText = function (time) {
    let type = Object.prototype.toString.call(time);
    if(type !== '[object Date]') {
        if(type === '[object String]') {
            time = getDate(time);
        } else {
            time = new Date(time);
        }
    }
    time = time.getTime();
    let now = Date.now();
    let offset = now - time;
    let text = "";
    if(offset < 0) {
        text = '未来';
    } else if ( offset < 60 * 1000) {
        text = "刚刚"
    } else if (offset < 60 * 60 * 1000) {
        text = `${Math.floor(offset / (60 * 1000))}分钟前`;
    } else if (offset < 24 * 60 * 60 * 1000) {
        text = `${Math.floor(offset / (60 * 60 * 1000))}小时前`;
    }else if (offset < 30 * 24 * 60 * 60 * 1000) {
        text = `${Math.floor(offset / (24 * 60 * 60 * 1000))}天前`;
    } else if(offset < 365 * 24 * 60 * 60 * 1000) {
        text = `${Math.floor(offset / (30 * 24 * 60 * 60 * 1000))}个月前`;
    } else {
        text = text = `${Math.floor(offset / (365 * 24 * 60 * 60 * 1000))}年前`;
    }
    return text;
}

const isEmpty = function (str) {
    return str === undefined || str === null || str === '' || str === false;
}

const checkValue = function (rules, value) {
    let tip = null;
    if(rules) {
        rules.every(rule => {
            let msg = rule.message;
            for(let key in rule) {
                if(key == "message") return true;
                let rv = rule[key];
                if(key == 'require') {
                    if(rv && isEmpty(value)) {
                        tip = msg;
                        return false;
                    }
                } else if(key == 'min' || key == 'max') {
                    let l = value.length;
                    if((key == 'min' && l < rv) || (key == 'max' && l > rv)) {
                        tip = msg;
                        return false;
                    }
                } else if(key == 'small' || key == 'big') {
                    let l = value * 1;
                    if(isNaN(l)) {
                        msg = '请输入数字';
                        return false;
                    } else if((key == 'small' && l < rv) || (key == 'big' && l > rv)) {
                        tip = msg;
                        return false;
                    }
                } else if(key == 'regex') {
                    let regexp = new RegExp(rv);
                    if(!regexp.test(value)) {
                        tip = msg;
                        return false;
                    }
                } else {
                    return true;
                }
            }
        });
    }
    return tip;
}

const getQuery = function (key) {
    let query = {};
    let search = location.search.substr(1).split(/[?&]/);
    search.forEach(item => {
        let temp = item.split("=");
        if(temp.length > 1) {
            query[temp[0]] = temp[1];
        }
    });
    if(key) {
        return query[key];
    } else {
        return query;
    }
}

export { isUrl, getDate, getNowTimeText, checkValue, getQuery };
